import Box from "@mui/material/Box"
import IconButton from "@mui/material/IconButton"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import { DeleteOutlined, EditOutlined, MoreVertOutlined } from "@mui-symbols-material/w300"
import type { Row } from "@tanstack/react-table"
import type { ReactNode } from "react"
import { useRef, useState } from "react"

import type { CompanyRegistration } from "@/graphql/codegen/graphql"

export const RegistrationActionsMenu = ({
  row,
  onEdit,
  onRemove,
}: {
  row: Row<CompanyRegistration>
  onEdit: (registration: CompanyRegistration) => void
  onRemove: (registration: CompanyRegistration) => void
}): ReactNode => {
  const anchorElRef = useRef<HTMLButtonElement>(null)

  const [open, setOpen] = useState(false)
  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleEdit = () => {
    onEdit(row.original)
    handleClose()
  }

  const handleRemove = () => {
    onRemove(row.original)
    handleClose()
  }

  return (
    <Box
      className='flex items-center justify-center'
      onClick={(event) => {
        event.stopPropagation()
      }}
    >
      <IconButton onClick={handleOpen} ref={anchorElRef}>
        <MoreVertOutlined />
      </IconButton>
      <Menu
        anchorEl={anchorElRef.current}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={handleEdit}>
          <ListItemIcon>
            <EditOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
          </ListItemIcon>
          <ListItemText primary='Edit' />
        </MenuItem>
        <MenuItem onClick={handleRemove}>
          <ListItemIcon>
            <DeleteOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
          </ListItemIcon>
          <ListItemText primary='Delete' />
        </MenuItem>
      </Menu>
    </Box>
  )
}
